import { connect } from 'redux-bundler-react';

const ClientPrivacyMask = ({ client, privacyMode, pii, masked }) => {
  return client.clientNameOrFake(privacyMode);
};

export default connect('selectPrivacyMode', ClientPrivacyMask);
